import React from "react";
import { animateScroll as scroll } from "react-scroll";
import { FaFacebook, FaInstagram, FaTwitter, FaYoutube } from "react-icons/fa";
import {
  FooterContainer,
  FooterLink,
  FooterLinkItems,
  FooterLinksContainer,
  FooterLinksWrapper,
  FooterLinkTitle,
  FooterWrap,
  SocialIconLink,
  SocialIcons,
  SocialLogo,
  SocialLogoImg,   // ✅ AJOUT
  SocialMedia,
  SocialMediaWrap,
  WebsiteRights,
} from "./FooterElements";

// ✅ ton logo (adapte le chemin)
import LogoPng from "../../image/icon.png";

const Footer = () => {
  const toggleHome = () => {
    scroll.scrollToTop();
  };

  return (
    <FooterContainer>
      <FooterWrap>
        <FooterLinksContainer>
          <FooterLinksWrapper>
            <FooterLinkItems>
              <FooterLinkTitle>Á Propos </FooterLinkTitle>
              <FooterLink to="/">Testimonials</FooterLink>
              <FooterLink to="/">Carrières</FooterLink>
              <FooterLink to="/">Terms of Service</FooterLink>
            </FooterLinkItems>

            <FooterLinkItems>
              <FooterLinkTitle>Contactez nous</FooterLinkTitle>
              <FooterLink to="/">Contact</FooterLink>
              <FooterLink to="/">Support</FooterLink>
              <FooterLink to="/">Sponsorships</FooterLink>
            </FooterLinkItems>
          </FooterLinksWrapper>
        </FooterLinksContainer>

        <SocialMedia>
          <SocialMediaWrap>
            {/* ✅ LOGO à la place du texte */}
            <SocialLogo to="/" onClick={toggleHome} aria-label="Accueil">
              <SocialLogoImg src={LogoPng} alt="Dieli" />
            </SocialLogo>

            <WebsiteRights>
              Dieli Copyright {new Date().getFullYear()} — All rights reserved.
            </WebsiteRights>

            <SocialIcons>
              <SocialIconLink
                href="https://www.facebook.com/profile.php?id=61580605480966"
                target="_blank"
                aria-label="Facebook"
                rel="noopener noreferrer"
              >
                <FaFacebook />
              </SocialIconLink>

              <SocialIconLink
                href="https://www.instagram.com/dieligroup/"
                target="_blank"
                aria-label="Instagram"
                rel="noopener noreferrer"
              >
                <FaInstagram />
              </SocialIconLink>

              <SocialIconLink
                href="https://mobile.twitter.com/dieligroup"
                target="_blank"
                aria-label="Twitter"
                rel="noopener noreferrer"
              >
                <FaTwitter />
              </SocialIconLink>

              <SocialIconLink
                href="https://m.youtube.com/channel/UCRlKpkcs8HxXmgXqH6gFctw/featured"
                target="_blank"
                aria-label="Youtube"
                rel="noopener noreferrer"
              >
                <FaYoutube />
              </SocialIconLink>
            </SocialIcons>
          </SocialMediaWrap>
        </SocialMedia>
      </FooterWrap>
    </FooterContainer>
  );
};

export default Footer;